   
<template>

</template>
<script>
export default { 
		data () {
			return {
			}
		},
		methods:{
			
			//微信匿名登陆
			loginByAnonymous(){
				var that=this;
				var	data ={
						"LoginType": 6,
					};
				that.postRequest({
					url:that.Api.anonymous, 
					params:data
				}).then(res => {
					if(res&&res.IsSuccess){
					    if(res.Result.AccessToken){
					    		//登陆成功后，保存登陆信息到本地localstorage
				    		that.dao.set('userInfo',JSON.stringify(res.Result));
				    		that.setHttpHeaders(res.Result.AccessToken);
				    		var url=this.dao.get('lastPageUrl')||'';
				    		if(url&&(url.indexOf("frHotelDetails")>-1||url.indexOf("hotelDetails")>-1||url.indexOf("presaleDetails")>-1||url.indexOf("packageDetails")>-1||url.indexOf("BookDetails")>-1)){
				    			that.$router.push(url);
				    		}else{
				    			that.$router.push('/');
				    		}
					    }
					}else{
				    	var protocol = window.location.protocol + '//';
			  			var location=window.location.href;
				    	window.location.href=protocol+'lmy.cnbooking.net/getWXCode.html?path=login'+'&url='+location;
				    	
				    }
				})
			}
			
		},
		mounted(){
			this.loginByAnonymous()
		},
}
</script>



// WEBPACK FOOTER //
// src/components/usr/anonymLogin.vue